// extracted by mini-css-extract-plugin
export default {"aboutSlider":"slider-about_aboutSlider__BPToN","img":"slider-about_img__PB0wn","textInfo":"slider-about_textInfo__R4EE7"};